import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function FileTemplate() {
  const { username, id } = useParams();
  const [fileData, setFileData] = useState(null);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/social-net/scan/${id}`
      );
      const file = response.data.data.data;
      setFileData(file);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [id]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      {fileData ? (
        <>
          <button
            onClick={() => window.open(fileData.fileLink, "_blank")}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              margin: "10px",
              cursor: "pointer",
            }}
          >
            📥 Download File
          </button>
          <button
            onClick={() => (window.location.href = "https://demo.dirido.com/")}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor: "red",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            🏠 Go Home
          </button>
        </>
      ) : (
        <p>Loading file details...</p>
      )}
    </div>
  );
}

export default FileTemplate;
